import { render, staticRenderFns } from "./aStaffDetailList.vue?vue&type=template&id=0480187a&scoped=true"
import script from "./aStaffDetailList.vue?vue&type=script&lang=js"
export * from "./aStaffDetailList.vue?vue&type=script&lang=js"
import style0 from "./aStaffDetailList.vue?vue&type=style&index=0&id=0480187a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480187a",
  null
  
)

export default component.exports